import cx from 'classnames';
import { MDText } from 'i18n-react';

import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';

import { desktopImage, mobileImage } from './Images';
import texts from './SimilarVehiclesEmptyState.texts';

import styles from './SimilarVehiclesEmptyState.module.scss';

const localText = new MDText(texts);

export const SimilarVehiclesEmptyState: React.FC<{
	className?: string;
	description?: React.ReactNode;
	title?: React.ReactNode;
}> = ({ className, description, title }) => {
	const {
		breakpoints: { breakpointTabletMobile },
	} = useBreakpoint();

	return (
		<div className={cx(styles.container, className)}>
			<div className={styles.text}>
				<h2>{title ?? localText.translate('title')}</h2>
				<p>{description ?? localText.translate('description')}</p>
			</div>
			<div className={styles.image}>
				<picture>
					<source media={`(max-width: ${breakpointTabletMobile})`} srcSet={mobileImage.src} />
					<img alt="No vehicles found" loading="lazy" src={desktopImage.src} />
				</picture>
			</div>
		</div>
	);
};
